module.exports = __webpack_public_path__ + "img/business-2.7f77813b.png";